import type { IconData } from '@stacksjs/iconify-core'

export const warpSqueezeSolid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M24 1.5C13.224 1.5 6.913 5.35 3.91 7.927a3.09 3.09 0 0 0-1.022 3.071c.232 1.028.948 1.92 1.943 2.407c1.68.821 3.89 2.127 5.661 3.933C12.253 19.133 13.5 21.333 13.5 24s-1.247 4.867-3.008 6.662c-1.77 1.806-3.98 3.112-5.66 3.934c-.996.486-1.712 1.378-1.944 2.406a3.09 3.09 0 0 0 1.022 3.071C6.913 42.651 13.224 46.5 24 46.5s17.086-3.85 20.09-6.427a3.09 3.09 0 0 0 1.022-3.071c-.232-1.028-.948-1.92-1.943-2.407c-1.68-.821-3.89-2.127-5.662-3.933C35.747 28.867 34.5 26.667 34.5 24s1.247-4.867 3.007-6.662c1.772-1.806 3.981-3.112 5.662-3.933c.995-.487 1.71-1.38 1.943-2.407a3.09 3.09 0 0 0-1.022-3.071C41.086 5.349 34.776 1.5 24 1.5\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default warpSqueezeSolid
